export default __webpack_public_path__ + "img/22.63f550.png";